import React, {useContext, useEffect, useRef, useState} from 'react';
import {Col, Container, Form, Row} from "react-bootstrap";
import {EntityAccountsComponent} from "components/entity-accounts/EntityAccountsComponent";
import {MnyWiresContext} from "./context";
import {EntityAccountsContext} from "components/entity-accounts/context";
import * as URL from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import {dateToString, getCurBusDate, getMinPermissibleBusDate, pickerDateFormatToDate} from "utils/FormatUtils";
import {VALIDATION_IN_JS} from "../../../utils/Constants";
import {updateTradesFilterFormErrors as updateMnyWiresFilterFormErrors} from "../../../utils/ErrorUtils";
import {ActionPanelContext} from "../../../context/action";

export default function MnyWiresFilter() {

    const {mnyWiresPanelFilterState,mnyWiresResultsDisplayState,
        setMnyWiresResultsDisplayState, setMnyWiresPanelFilterState,
        clearMnyWiresPanelDisplayState, setShowGridToolbar} = useContext(MnyWiresContext)
    const {clearEntityAccounts, entityAccountsNoSwap,
        entityAccountsOptionsNoSwap, validateEntityAccountSearch, setManagerDetails} = useContext(EntityAccountsContext);
    const {makePostRequest} = useContext(SecurityContext);
    const {error} = useContext(ToastContext);
    const {setDefaultStatus} = useContext(ActionPanelContext)
    const [formErrors, setFormErrors] = useState({});
    const isManagerIdInitialized = useRef(false);

    // defautStatus is ALL
    useEffect(() => {
        setDefaultStatus('ALL')
        }
        ,[])

    // Initialize managerId to -1 ('ALL') only on a fresh page load (component mount).
    // Once initialized, navigating back to this page or refreshing entity options
    // will NOT overwrite the user's current entity selection.
    useEffect(() => {
        if (isManagerIdInitialized.current) {
            return;
        }
        if (!entityAccountsOptionsNoSwap) {
            return;
        }
        setManagerDetails(-1, 'ALL', true)
        isManagerIdInitialized.current = true;
    }, [entityAccountsOptionsNoSwap])

    const handleClear = () => {
        clearEntityAccounts(undefined,undefined,true)
        clearMnyWiresPanelDisplayState()
    }

    const validateSearch = ()=>{
        const {startDate, endDate} = mnyWiresPanelFilterState;
        let errors = {}
        errors = validateEntityAccountSearch(false,true);

        if (!startDate)
            errors['startDate'] = 'Please enter start date'

        if (!endDate)
            errors['endDate'] = 'Please enter end date'


        if (startDate && endDate){
            let startDateD = new Date(startDate).getTime();
            let endDateD = new Date(endDate).getTime();

            if (startDateD > endDateD){
                errors['startDate'] = 'Please ensure that the start date is before the end date'
                errors['endDate'] = 'Please ensure that the start date is before the end date'
            }
        }


        if (startDate && (dateToString(startDate) < getMinPermissibleBusDate()))
            errors['startDate'] = `Please ensure that the start date is on or after ${pickerDateFormatToDate(getMinPermissibleBusDate())}`;

        if (startDate &&  (dateToString(startDate) > getCurBusDate()))
            errors['startDate'] = `Please ensure that the start date is on or before ${pickerDateFormatToDate(getCurBusDate())}`;
        if (startDate &&  (dateToString(endDate) > getCurBusDate()))
            errors['endDate'] = `Please ensure that the end date is on or before ${pickerDateFormatToDate(getCurBusDate())}`;


        return errors
    }

    const handleRefresh = (e) => {
        e.preventDefault();

        let errors = {}
        if (VALIDATION_IN_JS) {
            errors = validateSearch()
        }
        if(Object.keys(errors).length > 0){
            setFormErrors(errors)
            return
        }
        // set status on action panel
         if (mnyWiresPanelFilterState?.status){
             setDefaultStatus(mnyWiresPanelFilterState?.status)
         }
        //
        const params = {
            accountId: entityAccountsNoSwap.accountId,
            managerId: entityAccountsNoSwap.managerId,
            status:mnyWiresPanelFilterState.status,
            dtStart: mnyWiresPanelFilterState.startDate ? dateToString(mnyWiresPanelFilterState.startDate) : null,
            dtEnd: mnyWiresPanelFilterState.endDate ? dateToString(mnyWiresPanelFilterState.endDate) : null,
        }

        const onSuccessResponse = (response) => {
            setShowGridToolbar(response.data.length >= 0)

            const mnyWiresDisplayState = JSON.parse(JSON.stringify(mnyWiresResultsDisplayState))
            mnyWiresDisplayState.resData = ([...response.data])
            mnyWiresDisplayState.wireSearch = params
            setMnyWiresResultsDisplayState(mnyWiresDisplayState);
        }
        const onErrorResponse = (err) => {
            console.error(err);
            error("Error refreshing money wires data")
        }

        makePostRequest(params,
            URL.MNY_WIRE_SEARCH_URL , onSuccessResponse, onErrorResponse);
    }

    const handleChange = (e) => {
        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        const mnyWiresPanelFilterStateDetail = JSON.parse(JSON.stringify(mnyWiresPanelFilterState));
        mnyWiresPanelFilterStateDetail[targetName] = targetValue
        setMnyWiresPanelFilterState(mnyWiresPanelFilterStateDetail);

        updateMnyWiresFilterFormErrors(targetName, targetValue, formErrors,
            setFormErrors, mnyWiresPanelFilterState);

    }


    return(<>

        <Container fluid className="mt-md-3 mt-sm-0">
            <Form>
                <h2 className="d-md-block d-none">Search</h2>
                <Row>
                    <EntityAccountsComponent entityOptional={true} accountOptional={true} addAllInEntity={true} hideSwapLob={true}/>

                    <Col sm={12} md={12}>
                        <Form.Group controlId="formMnyWiresStatus" className={'td-select'}>
                            <Form.Label className="filter-input-label">Status</Form.Label>
                            <Form.Control as="select" name ='status' value={mnyWiresPanelFilterState.status} onChange={event => handleChange(event, 'status')}>
                                <option value={'ALL'}>ALL</option>
                                <option value={"PEND"}>Pending</option>
                                <option value={"CAPPR"}>Approved</option>
                                <option value={"CMPLT"}>Completed</option>
                                <option value={"REJECT"}>Rejected</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col sm={6} md={12}>
                        <Form.Group controlId="formMnyWiresStartDate">
                            <Form.Label className="filter-input-label">Start Date</Form.Label>
                            <Form.Control type="date" name={'startDate'} value={mnyWiresPanelFilterState.startDate} onChange={event => handleChange(event, 'startDate')} isInvalid={!!formErrors.startDate}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.startDate}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={6} md={12}>
                        <Form.Group controlId="formMnyWiresEndDate">
                            <Form.Label className="filter-input-label">End Date</Form.Label>
                            <Form.Control type="date" name={'endDate'} value={mnyWiresPanelFilterState.endDate} onChange={event => handleChange(event, 'endDate')} isInvalid={!!formErrors.endDate}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.endDate}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" onClick={handleRefresh}>Refresh</button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3" onClick={handleClear}>Clear</button>
                    </Col>
                </Row>
            </Form>
        </Container>

    </>);}